import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { PhoneAndroid, Router as RouterIcon } from '@mui/icons-material';
import { SipDevicesPage } from './SipDevicesPage';
import { IngressTrunksPanel } from './IngressTrunksPanel';

export const TrunksAndDevicesPage: React.FC = () => {
  const [tab, setTab] = useState(0);
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>Ingress Trunks &amp; SIP Devices</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Connectivity overview for spotting registration / reachability problems across customer trunks and registered SIP devices.
      </Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab icon={<RouterIcon />} iconPosition="start" label="Ingress Trunks" />
        <Tab icon={<PhoneAndroid />} iconPosition="start" label="SIP Devices" />
      </Tabs>
      {/* Ingress Trunks tab */}
      <Box hidden={tab !== 0}>{tab === 0 && <IngressTrunksPanel />}</Box>
      {/* SIP Devices tab — existing page rendered unchanged */}
      <Box hidden={tab !== 1} sx={{ mx: -3 }}>{tab === 1 && <SipDevicesPage />}</Box>
    </Box>
  );
};
